import { Button } from '@/components/Button';
import { cn } from '@/utils/cn';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface PremiumFeatureOverlayProps {
  title?: string;
  message?: string;
  showUpgradeButton?: boolean;
  upgradeButtonText?: string;
  children?: ReactNode;
  className?: string;
}

export const PremiumFeatureOverlay: React.FC<PremiumFeatureOverlayProps> = ({
  title,
  message,
  showUpgradeButton = true,
  upgradeButtonText,
  children,
  className,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { i18n } = useTranslation();

  // Messages par défaut pour les limitations de visites
  const defaultTitle = t('premiumFeatureOverlay:visit-limit-exceeded');
  const defaultMessage = t('premiumFeatureOverlay:upgrade-subscription');
  const defaultButtonText = t('premiumFeatureOverlay:upgrade-now');

  const handleUpgrade = () => {
    // Action standard de redirection vers la page de facturation
    navigate(`/${i18n.language}/dashboard/pricing`);
  };

  return (
    <div className={'relative'}>
      {/* Contenu original */}
      {children}

      {/* Overlay de blocage */}
      <div
        className={cn(
          'absolute inset-0 z-20 flex items-start justify-center bg-black/40 backdrop-blur-md',
          className,
        )}
      >
        <div className="m-4 rounded-xl bg-white p-5 shadow-2xl">
          <h3 className="mb-3 text-center text-lg font-bold text-red-600">
            {title || defaultTitle}
          </h3>
          <p className="mb-4 text-center text-sm">
            {message || defaultMessage}
          </p>
          {showUpgradeButton && (
            <div className="flex justify-center">
              <Button className="bg-linko-light" onClick={handleUpgrade}>
                {upgradeButtonText || defaultButtonText}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
